import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MirariSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref}
      id="mirari-section"
      className="bg-white py-32 lg:py-40 px-8 lg:px-32"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div
          className={`mb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center gap-6 mb-6">
            <span className="text-2xl font-light tracking-wider text-gray-900">mirari</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-medium text-gray-900 mb-4">
            Collaboration with mirari
          </h2>
          <p className="text-base text-gray-500">Creative Studio from Montreal, Canada</p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Image */}
          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="w-full h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/895ce1609c329b6a0d2181b1995d6d0f.jpg"
                alt="mirari collaboration"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div
            className={`transition-all duration-700 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-medium text-gray-900 mb-6 leading-relaxed">
                  パフォーミングアーツをルーツに持つクリエイティブスタジオ
                </h3>
                <p className="text-base text-gray-700 leading-loose mb-4">
                  BITMOVESは、カナダ・モントリオールを拠点とするクリエイティブスタジオ{' '}
                  <strong>mirari</strong> と協業し、デジタルコンテンツやインタラクティブインスタレーションを日本で実現しています。
                </p>
                <p className="text-base text-gray-700 leading-loose mb-4">
                  mirariはパフォーミングアーツにルーツを持ち、人と空間を驚きと感動で結びつける没入型体験の創造を専門としています。
                </p>
                <p className="text-base text-gray-700 leading-loose">
                  このパートナーシップでは、mirariがコンセプト開発とデザインを担当し、BITMOVESが日本国内での製作・現場施工・統合を管理します。
                </p>
              </div>

              <div className="w-full h-px bg-gray-200" />

              <div>
                <p className="text-sm text-gray-500 leading-loose mb-4">
                  BITMOVES collaborates with <strong>mirari</strong>, a creative studio based in
                  Montreal, Canada, to bring digital content and interactive installations to life
                  in Japan. Known for their roots in the performing arts, mirari specializes in
                  crafting immersive experiences that connect people with space in surprising and
                  emotional ways.
                </p>
                <p className="text-sm text-gray-500 leading-loose">
                  Through this partnership, mirari handles the concept development and design of
                  each installation, while BITMOVES manages local production and implementation in
                  Japan — from fabrication to onsite integration.
                </p>
              </div>

              {/* Role Division */}
              <div className="grid grid-cols-2 gap-6 pt-4">
                <div className="bg-gray-50 rounded-xl p-6">
                  <p className="text-xs uppercase tracking-wider text-gray-400 mb-3">
                    mirari
                  </p>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Concept &amp; Design</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Creative Direction</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Software Development</span>
                    </li>
                  </ul>
                </div>
                <div className="bg-gray-50 rounded-xl p-6">
                  <p className="text-xs uppercase tracking-wider text-gray-400 mb-3">
                    BITMOVES
                  </p>
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Local Production</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Hardware Engineering</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-gray-300 mt-0.5">—</span>
                      <span>Onsite Integration</span>
                    </li>
                  </ul>
                </div>
              </div>

              <a
                href="http://mirari.art"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 text-sm font-medium text-gray-900 hover:text-gray-600 transition-colors cursor-pointer pt-2"
              >
                mirari.art を見る
                <i className="ri-external-link-line text-base w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
